import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { Box } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { OrGroup as SharedOrGroup } from '~/components/AiSearchChips/OrGroup/OrGroup';
import sharedStyles from '~/components/AiSearchChips/OrGroup/OrGroup.module.scss';
import { OrValueGroupChip } from '~/components/AiSearchChips/OrValueGroupChip/OrValueGroupChip';
import { collapsedValueGroupValues } from '~/components/AiSearchChips/OrValueGroupChip/orValueGroupCollapse';
import { useSettingsChipTone } from '~/components/AiSearchChips/settingsChipTone';
import { useLocaleKeys } from '~/i18n';
import { PredicateChips } from '~/pages/DraftsDashboard/DraftsAiSearch/DraftsAiSearchChips/PredicateChips/PredicateChips';
import { useDraftsChipConnector } from '../draftsChipConnector';
import { draftsOrValueGroupFields, draftsOrValueGroupTexts } from '../draftsOrValueGroupFields';
import { armChipTestIds, collapsedGroupArm, collapsedGroupTone, collapsibleGroup } from './OrGroup.utils';
export const GetOrGroupTID = (parentTestId)=>getTestIds(parentTestId);
export const OrGroup = (param)=>{
    let { testId, arms, tone, onArmChange, onToggleConnector, onClearGroup } = param;
    const { OrGroupTestIds } = useMemo(()=>GetOrGroupTID(testId), [
        testId
    ]);
    const settingsTone = useSettingsChipTone();
    const connector = useDraftsChipConnector();
    const { t } = useLocaleKeys('proposal.draftsDashboard.aiSearch');
    const armChips = (arm, index)=>/*#__PURE__*/ _jsx(PredicateChips, {
            predicate: arm,
            onChange: (next)=>onArmChange(index, next),
            testIds: armChipTestIds(OrGroupTestIds.Arm(index))
        });
    const renderArm = (arm, index)=>[
            {
                key: 'chips',
                node: armChips(arm, index)
            }
        ];
    if (arms.length === 0) return null;
    const collapsed = collapsibleGroup(arms);
    if (collapsed != null) {
        return /*#__PURE__*/ _jsx(Box, {
            testId: OrGroupTestIds.Root(),
            inline: true,
            className: sharedStyles.group,
            children: /*#__PURE__*/ _jsx(OrValueGroupChip, {
                testId: OrGroupTestIds.ValueGroup(),
                field: collapsed.field,
                fields: draftsOrValueGroupFields(t),
                values: collapsedValueGroupValues(collapsed),
                connectorTone: tone,
                tone: collapsedGroupTone(collapsed, settingsTone),
                texts: draftsOrValueGroupTexts(t),
                bi: {
                    edit: {
                        name: 'drafts_ai_search_chip_value_group_edit'
                    },
                    apply: {
                        name: 'drafts_ai_search_chip_value_group_apply'
                    },
                    remove: {
                        name: 'drafts_ai_search_chip_value_group_remove'
                    }
                },
                onValueChange: (index, value)=>onArmChange(index, collapsedGroupArm(collapsed, index, value)),
                onRemove: onClearGroup
            })
        });
    }
    return /*#__PURE__*/ _jsx(SharedOrGroup, {
        testIds: {
            root: OrGroupTestIds.Root(),
            arm: OrGroupTestIds.Arm,
            connector: OrGroupTestIds.Connector
        },
        arms: arms,
        tone: tone,
        connector: connector,
        armGap: 4,
        armWrap: false,
        groupWrap: true,
        onToggle: onToggleConnector,
        renderArm: renderArm
    });
};
